/**
 * This dialog is shown when a user tries to reschedule scheduled updates
 * from either the scheduled updates sidebar or from an individual field.
 *
 * @author Kevin Wang (kwang@yext.com)
 */
goog.module('yext.scheduledupdates.dialog.RescheduleDialog');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const dialog = goog.require('yext.dialog');
const notify = goog.require('yext.notify');
const OverrideUpdateDialog = goog.require('yext.scheduledupdates.dialog.OverrideUpdateDialog');
const ActionResultDialog = goog.require('yext.scheduledupdates.dialog.ActionResultDialog');
const ActionDialog = goog.require('yext.scheduledupdates.dialog.ActionDialog');
const Base = goog.require('yext.scheduledupdates.dialog.Base');
const ValidationErrorDialog = goog.require('yext.scheduledupdates.dialog.ValidationErrorDialog');
const routes = goog.require('yext.scheduledupdates.routes');
const time = goog.require('yext.time');
const DatePicker = goog.require('yext.scheduledupdates.DatePicker');

/**
  * Constructor for the RescheduleDialog
  *
  * @param {string} date                      The date of scheduled updates you're rescheduling
  * @param {string=} opt_selectedFieldId       Which field we should select by default
  * @param {string=} opt_selectedCustomFieldId Which field we should select by default
  *
  * @constructor
  */
const RescheduleDialog = function(date, opt_selectedFieldId, opt_selectedCustomFieldId) {
  var $dialog = $('.js-reschedule-updates-dialog');
  ActionDialog.call(this, date, opt_selectedFieldId, opt_selectedCustomFieldId, $dialog);
};
// Inherit ScheduleUpdateDialog methods
goog.inherits(RescheduleDialog, ActionDialog);

/**
  * Actually populates the dialog on the page
  */
RescheduleDialog.prototype.show = function() {
  var options = {
    container: this.$dialog,
    title: yext.msg('Reschedule Updates for {0}', time.formatLocalizedDate(this.date, 'medium')),
  };
  options.container.find('.js-scheduled-fields').html(this.getBody());

  var $submit = options.container.find('.js-submit-btn');

  var self = this;
  this.datepicker = new DatePicker(
    options.container.find('.js-datepicker-input'),
    $submit,
    {minDate: 1},
    function(inputDate) {
      return self.validateDialog(inputDate);
    });

  this.$dialog.off('submit').on('submit', function() {
    self.apply();
  });

  new Base(options).show();
};

/**
 * @param {Date} inputDate  the date to validate
 *
 * @return {bool} True if inputDate is a valid date and at least one checkbox is selected, false otherwise
 */
RescheduleDialog.prototype.validateDialog = function(inputDate) {
  return this.multiSelect.getCheckedOptions().length > 0
    && inputDate > new Date()
    && this.date !== time.formatDateIso(inputDate);
};

/**
 * @override
 */
RescheduleDialog.prototype.checkEnableSubmit = function() {
  try {
    this.$dialog.find('.js-submit-btn').prop('disabled', !this.validateDialog(this.datepicker.parseDate()));
  } catch (err) {
    this.$dialog.find('.js-submit-btn').prop('disabled', true);
  }
};

/**
  * Generates the html for the body of this reschedule dialog
  */
RescheduleDialog.prototype.getBody = function() {
  // Construct date picker
  var result = this.getFieldOptions();
  var $rescheduleMsg = this.$dialog.find('.js-reschedule-prompt');
  $rescheduleMsg.toggle(false);
  if (result.error) {
    return yext.msg('Could not retrieve scheduled updates for this day.');
  } else if (result.options.length) {
    $rescheduleMsg.toggle(true);
    return this.getMultiSelectBody(result.options);
  } else {
    return yext.msg('There are no scheduled updates for this day');
  }
};

/**
 * This function is called when the user decides to hit Apply, we will fire of a request to actually reschedule the
 * scheduled updates and then redirect the user back to the primary profile.
 * @suppress {deprecated}
 */
RescheduleDialog.prototype.apply = function() {
  var checkedOptions = this.multiSelect.getCheckedOptions();
  var checkedFieldNames = [];
  checkedOptions.forEach(function(option) {
    checkedFieldNames.push(option.id);
  });

  var oldDate = this.date;
  var newDate = time.formatDateIso(this.$dialog.find('.js-datepicker-input').datepicker('getDate'));
  var isBulk = this.$dialog.data('isbulk');
  var url = routes.reschedule() + window.location.search;
  var requestData = {
    newDate: newDate,
    oldDate: oldDate,
    fieldNames: checkedFieldNames,
    overrideExisting: false,
  };

  var locationIds = yext.getUrlParams().ids;
  if (locationIds) {
    requestData.ids = decodeURIComponent(locationIds).split(',');
  }

  var self = this;
  var makeRequest = function() {
    self.dialogTimeout = dialog.showDelayedProgressDialog(yext.msg('Saving...'));
    $.ajax({
      url: url,
      type: 'POST',
      data: requestData,
      success: function(result) {
        self.$dialog.unbind();
        if (result.error) {
          dialog.showErrorDialog(result.error, yext.msg('Error rescheduling updates'));
        } else if (result.status == 'SUCCESS') {
          notify.showSuccess(yext.msg('Successfully rescheduled updates! Your page will refresh momentarily.'));
          self.loadNextPage();
        } else if (result.status == 'OVERRIDE_REQUIRED') {
          requestData.overrideExisting = true;
          OverrideUpdateDialog(makeRequest);
        } else if (result.status == 'FAILURE') {
          if (isBulk) {
            if (result.errors) {
              // Bulk Entity Validation error handling
              dialog.showErrorDialog(yext.msg('Your selected fields cannot be rescheduled to {0} because ' +
                'there are errors in one or more of your bulk selected fields. ' +
                'To view the errors, reschedule them by each entity individually.', time.formatLocalizedDate(newDate, 'medium')), yext.msg('Scheduled Updates Errors'));
            } else {
              // Bulk Location Validation error handling
              dialog.showErrorDialog(yext.msg('Your selected fields cannot be rescheduled to {0} because ' +
                'there are errors in one or more of your bulk selected fields. ' +
                'To view the errors, reschedule them by each location individually.', time.formatLocalizedDate(newDate, 'medium')), yext.msg('Scheduled Updates Errors'));
            }
          } else if (result.data || result.errors) {
            // Location/entity Validation error handling
            const errors = result.data || result.errors;
            new ValidationErrorDialog(checkedFieldNames.length, errors, newDate).show();
          } else {
            dialog.showErrorDialog(yext.msg('Your selected fields cannot be rescheduled to {0} because ' +
            'there are errors in one or more of your selected fields.', time.formatLocalizedDate(newDate, 'medium')), yext.msg('Scheduled Updates Errors'));
          }
        } else {
          // This will happen upon an exception that was caught, such as timeout exception
          dialog.showErrorDialog(yext.msg('Error rescheduling updates'));
        }
      },
      error: function() {
        dialog.showErrorDialog(yext.msg('Error rescheduling updates'));
      },
      complete: function() {
        dialog.hideDelayedProgressDialog(self.dialogTimeout);
      },
      async: true,
    });
  };
  makeRequest();
};

exports = RescheduleDialog;
